import React, { useState, useEffect } from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Chip from '@mui/material/Chip';
import axios from 'axios';

const TestListSearch = ({ testCodeList, districts, onSearch, onClear }) => {
  const [selectedTest, setSelectedTest] = useState('');
  const [year, setYear] = useState(''); // 年份（民國年）
  const [district, setDistrict] = useState(''); // 地點
  const [addressData, setAddressData] = useState([]);
  const [selectedAddresses, setSelectedAddresses] = useState([]);

  useEffect(() => {
        const fetchAddressData = async () => {
      try {
        const [ncuResponse, footBridgeResponse, underPassResponse] = await Promise.all([
          axios.get('https://tybms.tycg.gov.tw/newApi/NcuInventory'),
          axios.get('https://tybms.tycg.gov.tw/newApi/FootBridge'),
          axios.get('https://tybms.tycg.gov.tw/newApi/UnderPass_Info')
        ]);

        // 整合三個 API 回應資料
        const formattedData = [];

        ncuResponse.data.forEach(item => {
          formattedData.push({ id: item.id + "C", bridge_Id: item.bridge_Id, bridge_Name: item.bridge_Name });
        });

        footBridgeResponse.data.forEach(item => {
          formattedData.push({ id: item.id + "F", bridge_Id: item.bridge_Id, bridge_Name: item.bridge_Name + "(人)" });
        });

        underPassResponse.data.forEach(item => {
          formattedData.push({ id: item.fid + "U", bridge_Id: "", bridge_Name: item.name });
        });

        setAddressData(formattedData);
      } catch (error) {
        console.error('Error fetching address data:', error);
      }
    };

    fetchAddressData();
  }, []);

  // 轉換年份為民國年
  const handleYearChange = (date) => {
    const westernYear = date.getFullYear();
    const rocYear = westernYear - 1911; // 民國年轉換
    setYear(rocYear);
  };

  const handleSearch = () => {
    const bridgeName = selectedAddresses.length > 0 ? selectedAddresses[0].bridge_Name : '';
    const bridgeNumber = selectedAddresses.length > 0 ? selectedAddresses[0].bridge_Id : '';

    // 構建查詢條件
    const searchConditions = [];

    if (bridgeName) {
      searchConditions.push({ key: 'bridgeName', value: bridgeName });
    }

    if (bridgeNumber) {
      searchConditions.push({ key: 'bridgeNumber', value: bridgeNumber });
    }

    if (selectedTest) {
      searchConditions.push({ key: 'testName', value: selectedTest });
    }

    // 調用 onSearch 函數，傳遞查詢條件
    onSearch(searchConditions);
  };

  const handleClear = () => {
    setSelectedTest('');
    setYear('');
    setDistrict('');
    setSelectedAddresses([]);
    onClear();
  };

  return (
    <>
      <div className="text-left d-flex">
        <h5>待試驗橋梁</h5>
        {/* <div className="o-box__btn showmap-btn">
          <div className="o-btn-orientation--hori">
            {mapShow ?
              <div className="o-btn-group">
                <button className="o-btn o-btn--text js-left-box__shrimp" onClick={ToggleMapSideBar}>
                  <i className="o-btn__icon icon-right-dir"></i>
                  不顯示地圖
                </button>
              </div>
              :
              <div className="o-btn-group">
                <button className="o-btn o-btn--text js-left-box__hide" onClick={ToggleMapSideBar}>
                  <i className="o-btn__icon icon-left-dir"></i>
                  顯示地圖
                </button>
              </div>
            }
          </div>
        </div> */}
      </div>
      <div className="row">
        
        <div className="col-lg-6 d-flex align-items-center my-2">
          <h6 style={{ width: '125px' }}>所在區鄉：</h6>
          <select value={district} onChange={(e) => setDistrict(e.target.value)}>
            <option value="">選擇區鄉</option>
            {districts.map((dist, index) => (
              <option key={index} value={dist}>
                {dist}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="row">
        <div className="col-lg-6 d-flex align-items-center my-2">
          <h6 style={{ width: '109px' }}>橋梁選擇：</h6>
          <Autocomplete
            style={{ width: '500px' }}
            multiple
            id="tags-filled"
            options={addressData}
            getOptionLabel={(option) => `${option.bridge_Id} ${option.bridge_Name}`}
            value={selectedAddresses}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            onChange={(event, value) => {
              setSelectedAddresses(value);
            }}
            renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                <Chip
                  variant="outlined"
                  label={`${option.bridge_Id} ${option.bridge_Name}`}
                  {...getTagProps({ index })}
                />
              ))
            }
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="選擇橋"
                required
              />
            )}
          />
        </div>


      </div>

      <div className="col-lg-4 d-flex my-2 justify-content-end w-100">
        <button className="btn btn-primary" onClick={handleSearch}>查詢</button>
        <button className="btn btn-danger" onClick={handleClear}>清除</button>
      </div>
  </>
  );
};

export default TestListSearch;
